import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Header from "./Header";
import Warning from "../../../Components/common/Warning/Warning";
import Spinner from "../../../Components/common/Spinner/Spinner";
import Tooltip from "../../../Components/common/Tooltip/Tooltip";

import { RequestResetSettings } from "../../../store/actions/mailGatewayActions";
import { RequestRepairSettings } from "../../../store/actions/mailGatewayActions";

const ResetSettingsForm = ({ selectedProduct, selectedHost }) => {
  const dispatch = useDispatch();

  const resetSettingsLoading = useSelector((state) => state.mailGateway.resetSettingsLoading);
  const repairSettingsLoading = useSelector((state) => state.mailGateway.repairSettingsLoading);

  const [showWarning, setShowWarning] = useState(false);
  const [showWarningRepair, setShowWarningRepair] = useState(false);

  const handleResetSettings = () => {
    if (resetSettingsLoading) return;
    dispatch(RequestResetSettings(selectedHost));
    setShowWarning(false);
  };

  const handleRepairSettings = () => {
    if (repairSettingsLoading) return;
    dispatch(RequestRepairSettings(selectedHost));
    setShowWarningRepair(false);
  };

  return (
    <>
      <Header selectedProduct={selectedProduct} selectedHost={selectedHost} />
      <form className="products-body-form">
        <p className="light m-b-10 mailing__content__security__header">
              Reset Config Database
              <Tooltip text="Click the button below to reset config database in the mta" showFlowGrow={false} />
            </p>
        <button
          type="button"
          className="reset-button danger-button"
          onClick={() => {
            setShowWarning(true);
          }}>
          {resetSettingsLoading ? <Spinner width={14} height={14} /> : "Reset Config DB"}
        </button>
        <br/>
        <p className="light m-b-10 mailing__content__security__header">
              Repair and Update Config Database
              <Tooltip text="Click the button below to repair and update config database in the mta" showFlowGrow={false} />
            </p>
        <button
          type="button"
          className="reset-button default-button"
          onClick={() => {
            setShowWarningRepair(true);
          }}>
          {repairSettingsLoading ? <Spinner width={14} height={14} /> : "Repair Config DB"}
        </button>
      </form>
      <Warning
        onClickOk={handleResetSettings}
        show={showWarning}
        setShow={setShowWarning}
        text={`If you click yes, all the settings will be reset. Are you sure to reset settings ?`}
        article={`Confirm Reset Settings`}
        cancelDisable={false}
      />
      <Warning
        onClickOk={handleRepairSettings}
        show={showWarningRepair}
        setShow={setShowWarningRepair}
        text={`If you click yes, repair job will start. Are you sure to repair settings ?`}
        article={`Confirm Repair and Update Settings`}
        cancelDisable={false}
      />
    </>
  );
};

export default ResetSettingsForm;
